module.exports = __webpack_public_path__ + "static/media/reporting.48f26241.png";